import { createSelector } from '@reduxjs/toolkit';
import { getCodeTableDictionary } from '../codeTables/codeTables.state';
import { CodeTableNumber } from '../interfaces';
import { IsUserGlobalSelector } from '../security/session.state';

export const CurrentBusinessUnitPasswordRequirement = createSelector(
  [
    getCodeTableDictionary(CodeTableNumber.PasswordConfiguration),
    getCodeTableDictionary(CodeTableNumber.PasswordStrength),
    IsUserGlobalSelector
  ],
  (passwordConfigurations, strengthTypes, isGlobalUser) => {
    const passwordConfigurationsArray = Object.values(passwordConfigurations);
    if (
      Object.values(strengthTypes)?.length &&
      passwordConfigurationsArray?.length
    ) {
      //A Business Unit specific user must fallback to the global configuration if the
      //BU password configuration doesn't exist and the user is not global
      const buConfiguration = passwordConfigurationsArray.find(
        (configuration) => {
          return !configuration.Global;
        }
      );

      if (buConfiguration && !isGlobalUser) {
        return strengthTypes[
          buConfiguration.AdditionalProperties.user_password_strength_code
        ];
      }
      //Uses global password config if the user is defined as a global user in securityContext
      //even if the BU configuration exists or if the BU specific configuration doesn't exist
      //for a BU specific user that is not global
      const globalConfiguration = passwordConfigurationsArray.find(
        (configuration) => {
          return configuration.Global;
        }
      );

      if (globalConfiguration) {
        return strengthTypes[
          globalConfiguration.AdditionalProperties.user_password_strength_code
        ];
      }
    }

    return null;
  }
);
